/**
 * Created by sagardesai on 13/07/18.
 */

import * as types from "../../actions/types/index";
import { setInitialState } from "../../util/utility";

const INITIAL_STATE = setInitialState({
    payload: null,
    privateBroadcastPayload: null,
});

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.JOIN_BROADCAST_REQUEST:
        case types.JOIN_PRIVATE_BROADCAST_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.JOIN_BROADCAST_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                payload: action.payload.success
            };
        case types.JOIN_BROADCAST_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                payload: action.payload.response.error,
            };
        case types.RESET_JOIN_BROADCAST:
            return {
                ...state,
                payload: action.payload,
            };

        case types.JOIN_PRIVATE_BROADCAST_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                privateBroadcastPayload: action.payload.success
            };
        case types.JOIN_PRIVATE_BROADCAST_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                privateBroadcastPayload: action.payload.response.error,
            };
        case types.RESET_JOIN_PRIVATE_BROADCAST:
            return {
                ...state,
                privateBroadcastPayload: action.payload,
            };
        default:
            return {
                ...state
            }
    }
}